import { isNumeric } from "rxjs/internal-compatibility";

import { BaseCmsContentModel } from "../../../models/base-cms-content.model";
import { CmsContentAttributeModel } from "../../../models/cms-content-attribute.model";
import { CmsContentPropertyModel } from "../../../models/cms-content-property.model";

export class DirectoryItemModel extends BaseCmsContentModel {
    public id: string;

    public latitude: number;
    public longitude: number;

    public attributes: Array<CmsContentAttributeModel> = [];
    public properties: Array<CmsContentPropertyModel> = [];

    public constructor(model: any) {
        super();

        this.id = model.id;

        this.name = model.name;
        this.description = model.description;
        this.url = model.url;

        this.attributes = model.attributes;
        this.properties = model.properties;

        this.latitude = model.latitude;
        this.longitude = model.longitude;
    }

    public get imageUrl(): string { return this.getPropertyValue<string>("ListImagePath") || ""; }
    public get address(): string { return this.getPropertyValue<string>("Address") || ""; }
    public get postcode(): string { return this.getPropertyValue<string>("Postcode") || ""; }
    public get phone(): string { return this.getPropertyValue<string>("Phone") || ""; }
    public get email(): string { return this.getPropertyValue<string>("Email") || ""; }
    public get website(): string { return this.getPropertyValue<string>("Website") || ""; }

    public get hasValidAddress(): boolean {
        return this.address && (this.address !== ".");
    }

    public get hasValidPostcode(): boolean {
        return !!this.postcode;
    }

    public get hasValidPhoneNumber(): boolean {
        const phone = this.phone.toLowerCase();
        return phone && (phone !== "null");
    }

    public get hasValidEmailAddress(): boolean {
        const email = this.email.toLowerCase();
        return email && (email.indexOf("@") > 0) && (email !== "no@email.com");
    }

    public get hasValidWebsiteAddress(): boolean {
        const website = this.website.toLowerCase();
        return website && (website !== "#") && (website !== "null") && (website !== "no");
    }

    public get hasValidGeoLocation(): boolean {
        return this.latitude && isNumeric(this.latitude) && this.longitude && isNumeric(this.longitude);
    }

    protected hasProperty(alias: string): boolean {
        return this.properties.some(property => property.alias === alias);
    }

    protected getPropertyValue<T>(alias: string): T {
        return this.hasProperty(alias) ? this.properties.find(property => property.alias === alias).value as T : null;
    }
}
